// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"715":"6cbdf5fbfbeff1c3c22c","828":"f3550e93f735f60c1401"}[chunkId] + ".js";
};